import { ALTERNATIVE, COMPANY, COMPANY_FUND, CUSTOM_SECURITY, INDEX, MODEL_PORTFOLIO, MULTI_WATCHLIST, MUTUAL_FUND, SEPARATE_ACCOUNT, STOCK, } from '../constants/core.constants';
const detailedSecurityTypeToMetricMenuType = {
    alternative: ALTERNATIVE,
    benchmark_portfolio: MODEL_PORTFOLIO,
    cef: COMPANY_FUND,
    client_portfolio: MODEL_PORTFOLIO,
    custom_security: CUSTOM_SECURITY,
    stock: STOCK,
    company: COMPANY,
    etf: COMPANY_FUND,
    index: INDEX,
    model_portfolio: MODEL_PORTFOLIO,
    money_market_fund: MUTUAL_FUND,
    mutual_fund: MUTUAL_FUND,
    separate_account: SEPARATE_ACCOUNT,
    uit: MUTUAL_FUND,
    unlisted_cef: MUTUAL_FUND,
};
export const getMetricMenuType = (detailedSecurityType, withHistory) => {
    if (detailedSecurityType === MULTI_WATCHLIST) {
        return 'all';
    }
    let metricMenuType = detailedSecurityTypeToMetricMenuType[detailedSecurityType];
    if (!metricMenuType) {
        throw new TypeError('invalid detailedSecurityType');
    }
    if (withHistory) {
        metricMenuType = `${metricMenuType}_history`;
    }
    return metricMenuType;
};
export const getMetricSearchType = (detailedSecurityType, withHistory) => {
    return `${getMetricMenuType(detailedSecurityType, withHistory)}_calc`;
};
